import { DirectionType } from "./types";

interface InfoTextContainerProps {
  readonly type: DirectionType;
  readonly maxWidth: number;
  readonly children: React.ReactNode;
}

export function InfoTextContainer({ type, maxWidth, children }: InfoTextContainerProps) {
  return (
    <div
      className={`relative z-50 flex h-[21px] items-center gap-[5px] overflow-hidden ${type === "arrive" ? "top-[-21px]" : "top-[21px]"}`}
      style={{ maxWidth: `${maxWidth}px` }}
    >
      {children}
    </div>
  );
}
